import React from "react";
import logo from "../../assets/images/chart-icon.svg";

const chartLogo = props => <img src={logo} alt="chart" />;

export default chartLogo;
